<template>
  <div>
    <v-dialog v-if="modal.isLoading" :value="true" persistent width="300">
      <v-card>
        <v-card-text class="pt-3">
          Adatok letöltése
          <v-progress-linear indeterminate></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isModalOpen"
      transition="dialog-bottom-transition"
      :content-class="modal.isLoading ? 'd-none' : ''"
      eager
      scrollable
      v-bind="{ ...defOptions, ...modal.options }"
    >
      <slot @close="Close"></slot>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'base-modal',
  data() {
    return {
      defOptions: {
        maxWidth: '1600px',
      },
    };
  },
  mounted() {},
  created() {},
  methods: {
    Close() {
      console.log(this.modal);
    },
  },
  computed: {
    isModalOpen: {
      get() {
        return this.modal.isOpened && !this.modal.isLoading;
      },
      set(e) {
        // eslint-disable-next-line
        this.modal.isOpened = e;
      },
    },
  },
  watch: {},
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },
};
</script>
